// utils/android.js
import {
  isAndroid,
  isModernWebView,
  isLegacyNewsWebView,
  getAcceptLanguage,
  getAppType
} from '../android/bridge'

export const parseAndroidToken = (raw) => {
  if (!raw) return { kind: 'none' }

  const normalize = (obj) => {
    if (obj?.token_type?.toLowerCase() === 'jwt') {
      return {
        kind: 'jwt',
        access: obj?.access_token || obj?.token,
        refresh: obj?.refresh_token
      }
    }
    // legacy / django session formats
    const access = obj?.access_token || obj?.token || obj
    return { kind: 'legacy', access }
  }

  if (typeof raw === 'object') return normalize(raw)

  try {
    return normalize(JSON.parse(raw))
  } catch {
    // plain string like "Token abc123"
    return { kind: 'legacy', access: raw }
  }
}

/* ---------- headers to be merged into every request ---------------- */
export const getAndroidBasicHeaders = () => {
  /* not inside an Android WebView → nothing to add */
  if (!isAndroid()) return {}

  /* ─────── 1️⃣ legacy News WebView (no SDK payload) ─────── */
  if (isLegacyNewsWebView()) {
    return {
      'Accept-Language': 'en',
      'app-type': 'news'
    }
  }

  /* ─────── 2️⃣ modern SDK-based WebViews (Jobs / News) ─── */
  if (isModernWebView()) {
    return {
      'Accept-Language': getAcceptLanguage(),
      'app-type': getAppType()
    }
  }

  /* fallback – shouldn’t really happen */
  return {}
}
